import { categories } from '@/mocks/categories';

const gridBCategories = categories.slice(6, 9);

const gridBImages = [
  'https://readdy.ai/api/search-image?query=Coordinated%20two%20piece%20linen%20set%20in%20soft%20dusty%20blue%20tone%20draped%20over%20warm%20ivory%20surface%2C%20jacket%20and%20trousers%20styled%20together%2C%20soft%20studio%20lighting%20with%20gentle%20shadows%2C%20editorial%20fashion%20photography%20with%20visible%20natural%20fabric%20texture%2C%20muted%20cool%20tone%20palette%20with%20cream%20accents%2C%20relaxed%20coordinated%20composition&width=600&height=400&seq=grid-sets-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Organic%20cotton%20undergarment%20basics%20in%20warm%20cream%20and%20soft%20grey%20tones%20folded%20neatly%20on%20natural%20linen%20fabric%2C%20soft%20diffused%20window%20light%2C%20minimalist%20product%20photography%20with%20visible%20soft%20textile%20texture%2C%20clean%20neutral%20palette%2C%20refined%20essential%20composition&width=600&height=400&seq=grid-underwear-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Vintage%20wash%20heather%20grey%20sports%20jersey%20with%20subtle%20distressed%20detailing%20hung%20against%20warm%20ivory%20wall%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%20with%20visible%20cotton%20fleece%20texture%2C%20muted%20neutral%20tones%20with%20slate%20undertones%2C%20relaxed%20athletic%20aesthetic&width=600&height=400&seq=grid-jersey-v2&orientation=landscape',
];

export default function CategoryCardGridB() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950">
            Trending Now
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-md">
            Fresh categories updated regularly with the latest Superbuy Spreadsheet finds.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {gridBCategories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-background-300/80 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={gridBImages[idx]}
                  alt={`Superbuy Spreadsheet ${cat.name} products`}
                  title={`Superbuy Spreadsheet - ${cat.name}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
              </div>
              <div className="p-5 text-center">
                <h3 className="font-heading text-lg font-semibold text-foreground-900">{cat.name}</h3>
                <div className="mt-3">
                  <span className={`inline-flex items-center gap-1.5 px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${idx === 0 ? 'bg-primary-500 text-background-50 group-hover:bg-primary-600' : 'bg-background-100 text-foreground-700 border border-foreground-300/40 group-hover:border-foreground-400/60'}`}>
                    Explore
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                </div>
                <p className="text-xs text-foreground-400 mt-2">Click to browse on kaspreadsheet.com</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}